import React from 'react';
import { Redirect } from 'react-router';
import { useOnboardingContext } from 'Views/Onboarding/Contexts/OnboardingContext';
import dashboardOrOnboarding from 'Helpers/dashboardOrOnboarding';

const SignUpFlowCompleted = () => {
  const { clientResource } = useOnboardingContext();
  return <Redirect to={dashboardOrOnboarding(clientResource)} />;
};

export default SignUpFlowCompleted;
